import Swiper, { Navigation } from 'swiper'
import ModalVideo from '../partials/modal-video'

export default class SliderMidia {
  constructor() {
    this.slider = document.querySelector('.swiper--hero')
    this.navigationPrev = document.querySelector('.slider-button-prev--hero')
    this.navigationNext = document.querySelector('.slider-button-next--hero')
    this.sliderVideos = this.slider.querySelectorAll('[data-video]')

    this.initSlider()
    this.initVideos()
  }

  initSlider() {
    const swiper = new Swiper(this.slider, {
      modules: [Navigation],
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: this.navigationNext,
        prevEl: this.navigationPrev,
      },
    })
  }

  initVideos() {
    this.sliderVideos.forEach((el) => {
      el.addEventListener('click', () => {
        const urlVideo = el.dataset.video
        new ModalVideo(urlVideo)
      })
    })
  }
}
